export default function(pageName, pageParams, pageClasses, applicationId, application, sections, fields, form, backUrl, previewUrl) {
	this.wrap('page/wrapper', pageName, pageParams, pageClasses);
	let sectionId = null;
	let sectionIndex = -1;
	let firstSectionId = null;
	const sectionsMap = {};
	return `
		<div ${this.html.classAttr('application')} ${this.html.dataAttr({
			component: 'Application',
			application: applicationId,
			fields: fields,
			previewUrl: previewUrl,
			backUrl: backUrl,
			applicationClosing: +application.test ? 0 : application.closingDiff,
			expireMessage: application.expireMessage
		})}>
			<div ${this.html.classAttr('application__info')} ${this.html.dataAttr({applicationInfo: null})}>
				<div ${this.html.classAttr('application__progress')}>
					<span ${this.html.dataAttr({applicationProgress: null})}>0</span>%
				</div>
				<div ${this.html.classAttr('application__tabs', 'applicationTabs')} ${this.html.dataAttr({component: 'ApplicationTabs'})}>
					<ul ${this.html.classAttr('applicationTabs__items')}>
						${this.loop(sections, (section, index) => {
			sectionsMap[String(section.id)] = section;
			if (firstSectionId === null) {
				firstSectionId = String(section.id);
			}
			return this.render('application/tab', section, index, firstSectionId === String(section.id));
		})}
					</ul>
				</div>
			</div>
			${this.render('form/formOpen', form, 'sectionForm')}
				<div ${this.html.classAttr('application__sections')} ${this.html.dataAttr({component: 'ApplicationSections'})}>
					${this.loop(form.fields, (field, name) => {
			const fieldSectionId = field.sectionId;
			let printOpen = false;
			let printClose = false;
			if (fieldSectionId !== sectionId) {
				printOpen = true;
				if (sectionIndex >= 0) {
					printClose = true;
				}
				sectionId = fieldSectionId;
				sectionIndex++;
			}
			return `
							${printClose ? '</div></div>' : ''}
							${printOpen ? `
								<div ${this.html.classAttr('application__section', 'applicationSection', String(sectionId) === firstSectionId ? 'js-current' : '')} ${this.html.dataAttr({section: String(sectionId), index: sectionIndex})}>
									${this.cond(sectionsMap[sectionId].description.length, () => `
										<div ${this.html.classAttr('applicationSection__description', 'ugc')}>
											${sectionsMap[sectionId].description}
										</div>
									`)}
									<div ${this.html.classAttr('form__fields', 'applicationSection__fields')}>
							` : ''}
							${this.render('form/field', name, field)}
						`;
		})}
					</div>
						${this.render('form/actions', {
			submit: {
				align: 'start',
				actions: {
					submit: {
						attributes: {
							type: 'button'
						},
						data: {
							applicationSubmit: applicationId
						},
						label: this.text.get('application/submit')
					}
				}
			}
		})}
					</div>
				</div>
			${this.render('form/formClose')}
			<div ${this.html.classAttr('application__nav', 'applicationNav')} ${this.html.dataAttr({component: 'ApplicationNav'})}>
				<ul ${this.html.classAttr('applicationNav__items')}>
					${this.loop(sections, (section, index) => {
			const currentId = String(section.id);
			const prev = index > 0 ? {title: sections[index - 1].title, index: index - 1} : null;
			const prevId = prev ? String(sections[prev.index].id) : null;
			const next = index < sections.length - 1 ? {title: sections[index + 1].title, index: index + 1} : null;
			const nextId = next ? String(sections[next.index].id) : null;
			return `
							<li ${this.html.classAttr('applicationNav__item', index === 0 ? 'js-current' : '')} ${this.html.dataAttr({applicationNavItem: currentId})}>
								<div ${this.html.classAttr('applicationNav__actionWrapper')}>
									${prev ? `
										<button ${this.html.classAttr('applicationNav__action', 'button', 'button--seamless')} type="button" ${this.html.dataAttr({goTo: prevId})}>
											<span ${this.html.classAttr('applicationNav__actionIcon', 'button__icon')}>
												${this.html.svgIcon('left')}
											</span>
											<span ${this.html.classAttr('applicationNav__actionLabel')}>
												<span ${this.html.classAttr('applicationNav__actionIndex')}>${prev.index + 1}.</span>
												<span ${this.html.classAttr('applicationNav__actionName')}>${this.escape(prev.title)}</span>
											</span>
										</button>
									` : ''}
								</div>
								<div ${this.html.classAttr('applicationNav__actionWrapper', 'applicationNav__actionWrapper--back')}>
									<a href="${this.escape(this.url.getUrl(backUrl))}" ${this.html.classAttr('applicationNav__action', 'button')} type="button">
										<span ${this.html.classAttr('applicationNav__actionLabel')}>
											${this.escape(this.text.get('application/back'))}
										</span>
									</a>
								</div>
								<div ${this.html.classAttr('applicationNav__actionWrapper')}>
									${next ? `
										<button ${this.html.classAttr('applicationNav__action', 'button', 'button--seamless')} type="button" ${this.html.dataAttr({goTo: nextId})}>
											<span ${this.html.classAttr('applicationNav__actionLabel', 'button__label')}>
												<span ${this.html.classAttr('applicationNav__actionIndex')}>${next.index + 1}.</span>
												<span ${this.html.classAttr('applicationNav__actionName')}>${this.escape(next.title)}</span>
											</span>
											<span ${this.html.classAttr('applicationNav__actionIcon', 'button__icon')}>
												${this.html.svgIcon('right')}
											</span>
										</button>
									` : ''}
								</div>
							</li>
						`;
		})}
				</ul>
			</div>

		</div>
	`;
}
